import { EditOutlined, QuestionCircleOutlined, DeleteOutlined} from "@ant-design/icons";
import { Space, Table, Drawer , Button, Popconfirm } from 'antd';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import {useSelector } from 'react-redux';
import accountService from "../../../api/account.service";


import commonUtility from "../../../utility/Utils";
import { ADD_MODE, DEFAULT_MASTER_DRAWER_WIDTH, EDIT_MODE, SUCCESS_STATUS } from '../../../utility/Constants';
import DrawableCloseIcon from "../../common/DrawableCloseIcon";
import PaymentModeEntry from "./PaymentModeEntry";



const PaymentModeList = () => {
  const state = useSelector((state)=>state.paymentmode)
    const [visible, setVisible] = useState(false);

    const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
    const [page, setPage] = React.useState(1);
    
    const [isSuccessRefreshList, setIsSuccessRefreshList] = useState(false);
    const [paymentModeList, setPaymentModeList] = useState([]);
    const [paymentModeData, setPaymentModeData] = useState({
        id: 0,
        payment_mode: '',
        account_id: '',
        mode: EDIT_MODE,
        is_bank_details: 'N',
        bank_charges: 0,
    });
  
    const showDrawer = (rowdata) => {
    
    setPaymentModeData({
        id: rowdata.id,
        payment_mode: rowdata.payment_mode,
        account_id: rowdata.account_id,
        mode: EDIT_MODE,
        is_bank_details: rowdata.is_bank_details,
        bank_charges: rowdata.bank_charges,
    })
  
      setVisible(true);
  
    };
  
  
    const onClose = () => {
      setVisible(false);
    };
  
    const confirmDelete = (e) => {   
      
      const data = { formdata: { payment_mode_id: e} };
      accountService.deletePaymentMode(data).then((res) => {

        setIsSuccessRefreshList(false)
        if(res.response_status == SUCCESS_STATUS) {
          setIsSuccessRefreshList(true)
          // message.success(res.response_msg);
          commonUtility.openNotification("bottom", "Message", res.response_msg);
        }
        else{
          //message.error(res.response_msg);
          commonUtility.openNotification("bottom", "Message", res.response_msg);
        }
        
      });   

    };
    
    const cancel = (e) => {
      console.log("No clik",e);
      //message.error('Click on No');
    };
    
  
  
    const columns = [
      { 
        title: '#', 
        dataIndex: 'index', 
        render: (text, record, index) => (page - 1) * 10 + ++index ,
        width: '5%',
      },
      {
        title: 'Mode',
        dataIndex: 'payment_mode',
        key: 'payment_mode',
        sorter: (a, b) => a.payment_mode.localeCompare(b.payment_mode),
        
      },
      {
        title: 'Account',
        dataIndex: 'account_name',
        key: 'account_name',
        sorter: (a, b) => a.account_name.localeCompare(b.account_name),
      },
      {
        title: 'Bank Charge',
        dataIndex: 'bank_charges',
        key: 'bank_charges',
        align:'right',
        render: (selectedObj,values) => (
          <>{values.bank_charges > 0 ? values.bank_charges+"%" : 0}</>
        ),
      },
      
     
      {
        title: 'Action',
        key: 'action',

        width:'10%',
        render: (selectedObj) => (
          
          <Space size="middle">
               <>
              <Popconfirm
                title="Data cann't be undone if deleted. Do you want to delete? "
                icon={
                  <QuestionCircleOutlined
                    style={{
                      color: 'red',
                    }}
                  />
                }
                onConfirm={()=>confirmDelete(selectedObj.id)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <Button htmlType="button" type="danger" size="small" shape="round" >Delete <DeleteOutlined /></Button>
              </Popconfirm>
            </>
            <Button htmlType="button" type="ghost" size="small" shape="round" onClick={()=> showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
          </Space>
        ),
      },
    ];
  
  
    useEffect(() => {
        accountService.paymentModeList().then((res) => {
            // console.log(res.data.response_data);
            setPaymentModeList(res.data.response_data);
        });
    }, [state.paymentmode,isSuccessRefreshList])



  
    return (
      <>
        <Table 
          columns={columns} 
          rowKey='id' 
          dataSource={paymentModeList}
          pagination={{
            showTotal,
            onChange(current) {
              setPage(current);
            }
          }}
          size="small"
        />
  
        <Drawer
            title="Edit Payment Mode"
            width={DEFAULT_MASTER_DRAWER_WIDTH}
            onClose={onClose}
            visible={visible}
            bodyStyle={{
              paddingBottom: 80,
            }}
            destroyOnClose = {true}
            closeIcon = {<><DrawableCloseIcon /></>}
  
          >
            <PaymentModeEntry  data={paymentModeData} onDrawerClose={onClose}  />
          </Drawer>
  
      </>
    );
}

export default PaymentModeList